import { useReducer, createContext } from 'react';
export const FeatureContext = createContext();

//ΔVΔVΔ: Context Variables
const state_init = {
    pinnedFeature: null,
    hoveredFeature: null,
    modalIsPinned: false
};
// ΔVΔVΔ: Context Methods
const uiActions = (state, dispatch) => {
    return {
        setPinnedFeature: (feature) => dispatch({ type: 'setPinnedFeature', feature }),
        updateHoveredFeature: (feature, pixel) => dispatch({ type: 'updateHoveredFeature', feature, pixel }),
        pinWindow: (value) => dispatch({ type: 'pinWindow', value })
    };
};
// ΔVΔVΔ: Context State Transformation
function featureReducer(state, action) {
    switch (action.type) {
        case 'setPinnedFeature':
            return { ...state, pinnedFeature: action.feature };
        case 'updateHoveredFeature':
            return { ...state, hoveredFeature: action.feature };
        case 'pinWindow':
            return { ...state, modalIsPinned: action.value };
        default:
            return state;
    }
}

const FeatureProvider = ({ children }) => {
    const [state, dispatch] = useReducer(featureReducer, state_init);
    const value = {
        ...state,
        ...uiActions(state, dispatch)
    };
    return <FeatureContext.Provider value={value}>{children}</FeatureContext.Provider>;
};
export { FeatureProvider };
